import { commonErrors } from '@utils/error';
import { boolRadioButton } from '@utils/validation';
import { z } from 'zod';

export const dataConstants = {
	adhdDiagnosis: 'adhdDiagnosis',
};

export const testContent = {
	pageHeader:
		'Have you had a prior ADHD diagnosis, and received a prescription within the last 6 months?',
};

export const schema = z.object({
	adhdDiagnosis: boolRadioButton(commonErrors.selectionRequired),
});
